<template>
  <div class="gl-source-of-funds-search">
    <div class="gl-source-of-funds-search-wrapper">
      <GlCoinSelect />
      <GlSearchBox
        v-model="search"
        button-text="Generate Report"
        class="fullwidth gl-source-of-funds-search-input"
        dark-clear
        :disabled="isSearchDisabled"
        height="40px"
        :loading="calcLoading || addressDataLoading || txDataLoading"
        placeholder="Enter the wallet address"
        @search="searchData"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
//Components
import GlCoinSelect from '@/components/gl-coin-select'
import GlSearchBox from '@/components/gl-search-box'
import LimitsReachedModal from '@/pages/report/components/purchase/modals/LimitsReachedModal'

export default {
  components: {
    GlCoinSelect,
    GlSearchBox,
  },
  props: {
    msg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: '',
      addressDataLoading: false,
      txDataLoading: false,
      calcLoading: false,
      activeValue: '',
    }
  },
  computed: {
    ...mapState('analytics', ['coinType', 'coinData']),
    ...mapGetters('payment', ['getCurrentPlan']),
    ...mapGetters('subscribe', [
      'getSubscriptionPeriodEnded',
      'hasBillingIssue',
    ]),
    isSearchDisabled() {
      return (
        !this.search ||
        this.search.trim() === '' ||
        this.getSubscriptionPeriodEnded ||
        this.hasBillingIssue ||
        (this.getCurrentPlan?.hadSubscription &&
          this.getCurrentPlan.status === 'none')
      )
    },
  },
  methods: {
    ...mapMutations('analytics', ['SET_COIN_TYPE', 'SET_COIN_DATA']),
    ...mapActions('modal', ['openModal']),
    async searchData(value) {
      const { monthlyQuota, reportsRemaining } = this.getCurrentPlan || {}
      const isValidQuota = monthlyQuota !== undefined && monthlyQuota >= 0

      if (isValidQuota && reportsRemaining <= 0) {
        this.openModal({
          component: LimitsReachedModal,
          props: { limitInfo: { reportsRemaining, monthlyQuota } },
        })
        return
      }

      const valid = new RegExp(this.coinData.addressRegex).test(value)

      if (!valid) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Search value is not valid',
          life: 3000,
        })
        return
      }

      if (
        new RegExp(this.coinData.addressRegex).test(value) &&
        this.$can('use', this.coinData.family)
      ) {
        await this.$router.push({
          name: 'report',
          query: {
            type: this.coinType,
            address: value,
          },
        })
        return
      }

      this.$toast.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Search value is not valid',
        life: 3000,
      })
    },
  },
}
</script>
<style>
.gl-source-of-funds-search-wrapper {
  display: flex;
  gap: var(--grid-gap);
}
@media (max-width: 799px) {
  .gl-source-of-funds-search-wrapper {
    gap: 0;
  }
}
</style>
